import { Component, OnInit, Output, Input, OnDestroy, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { StoreService } from 'core/services';
@Component({
  selector: 'lms-chooser-column',
  templateUrl: './chooser-column.component.html',
  styleUrls: ['./chooser-column.component.scss']
})
export class ChooserColumnComponent implements OnInit, OnDestroy {
  @Output() change = new EventEmitter<Object>();
  @Input() listId: string;
  public listSubscription: any;
  public tableDatasource: any;
  public onChooserColumnActive: boolean = false;

  constructor(public elementRef: ElementRef) {}

  ngOnInit() {
    this.listSubscription = StoreService.get(this.listId).subscribe((tableDatasource) => {
      if (tableDatasource) {
        this.tableDatasource = tableDatasource;
      }
    });
  }

  ngOnDestroy() {
    this.listSubscription.unsubscribe();
  }

  onChooserColumn(columns) {
    this.tableDatasource.columns = columns;
  }

  onChooserColumnActiveComponent() {
    this.onChooserColumnActive = true;
  }

  @HostListener('document:click', ['$event'])
  hide(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.onChooserColumnActive = false;
    }
  }
}
